var map = {
	"./1.png": 8031,
	"./10.png": 4924,
	"./11.png": 173,
	"./12.png": 7859,
	"./2.png": 4899,
	"./3.png": 286,
	"./4.png": 4921,
	"./5.png": 9465,
	"./6.png": 8618,
	"./7.png": 301,
	"./8.png": 5703,
	"./9.png": 6616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9127;